<template>
<div class="section-layout">
  <div class="form-row mx-0 layout-all">
    <div class="col-12 col-md-6 px-0 layout-section">
      <form-block v-for="(fieldData, m) in getFields(0)" :key="m"
        :formdata="fieldData"
        :formIndex="m"
        class="form-group mx-3"></form-block>
    </div>
    <div class="col-12 col-md-6 px-0 layout-section">
      <form-block v-for="(fieldData, m) in getFields(1)" :key="m"
        :formdata="fieldData"
        :formIndex="m"
        :class="formBlockStyles(fieldData)"></form-block>
    </div>
  </div>
</div>
</template>

<script>
import FieldDisplay from '../FieldDisplay';
import FormBlock from '../FormBlock';
import { layoutOptions } from '../../../mixins/layoutOptions';
import { rulesMixin } from '../../../mixins/rulesMixin';
import { layout } from '../../../mixins/layout';

export default {
  props: ['group'],
  inject: ['$validator'],
  mixins: [
    rulesMixin,
    layout,
    layoutOptions,
  ],
  data() {
    return {
      sections: [],
      subSections: [],
      subSubSections: [],
      layout: null,
    };
  },
  components: {
    FieldDisplay,
    FormBlock,
  },
  methods: {
    /**
     * Remove duplicate values from an array.
     *
     * This is necessary to avoid repeating the 'untitled' value that represents
     * sections that do not have a name. Since all of the data is nested within
     * a section, a subsection, and a subsubsection, each needs a name to group
     * the fields together under their respective hierarchy. If, in the future,
     * the data is received in the tree structure it is supposed to be represented
     * as, then this and other steps are not necessary.
     */
    removeDuplicateValues(section) {
      return section.filter((item, pos, self) => self.indexOf(item) === pos);
    },
    /**
     * Returns the fields for either the 1st or 2nd columns.
     */
    getFields(columnIndex) {
      const fields = this.pageData.fields || [];
      const fieldsLength = fields.length;
      const fieldsBegin = (columnIndex === 0 ? 0 : (fieldsLength / 2));
      const fieldsEnd = (columnIndex === 0 ? (fieldsLength / 2) : fieldsLength);

      return fields.slice(fieldsBegin, fieldsEnd);
    },
    compileSectionNames() {
      /* eslint-disable no-restricted-syntax, no-prototype-builtins */

      for (const section in this.group) {
        if (this.group.hasOwnProperty(section)) {
          if (!this.sections[section]) {
            this.sections.push(section);
          }

          for (const subSection in this.group[section]) {
            if (this.group[section].hasOwnProperty(subSection)) {
              if (!this.subSections[subSection]) {
                this.subSections.push(subSection);
              }

              for (const subSubSection in this.group[section][subSection]) {
                if (this.group[section][subSection].hasOwnProperty(subSubSection)) {
                  if (!this.subSubSections[subSubSection]) {
                    this.subSubSections.push(subSubSection);
                  }
                }
              }
            }
          }
        }
      }

      this.sections = this.removeDuplicateValues(this.sections);
      this.subSections = this.removeDuplicateValues(this.subSections);
      this.subSubSections = this.removeDuplicateValues(this.subSubSections);
    },
  },
  mounted() {
    this.compileSectionNames();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/presentational/layouts/LayoutSplit.vue?780ba4e7